export function decodeBase64Email(email : string) : string {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

    return base64regex.test(email) ? atob(email) : email;
}